var mapFeatures=[];
var map = null;
// var ib;
// var marker;

// console.log(ib);

function timestamp2date(timestamp) {
var datestring = "";
var date = new Date(timestamp);
var year = date.getFullYear();
var month = date.getMonth() + 1;
var day = date.getDate();
var hours = "0" + date.getHours();
var minutes = "0" + date.getMinutes();
datestring = year + "-" + month + "-" + day + " " + hours.substr(-2) + ":" + minutes.substr(-2);
return datestring;
}

function add_vessels(map) {
require(["dojo/Deferred", "esri/request"], function(Deferred, esriRequest) {

 var url = 	"https://portal.gisdataserver.com/server/rest/services/Public/Public_Vessels_01182018/MapServer/0/query?where=1%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentsOnly=false&datumTransformation=&parameterValues=&rangeValues=&f=geojson";

    var	requestHandle = esriRequest({
            "url": url,
            "content": {
               "format": "json"
            },
            "handeAs": "json",
            "callbackParamName": "jsoncallback",
          });

	 requestHandle.then(requestSucceeded, requestFailed);

	  function requestSucceeded(response, io){
          var vessels_geojon = response;
          // console.log(vessels_geojon);

           var myOptions = {
            // content: boxText,
            disableAutoPan: false,
            maxWidth: 0,
            pixelOffset: new google.maps.Size(40, -85),
            zIndex: null,
            boxStyle: {
              background: "#ffffff",
              opacity: 1,
              width: "350px",
              height: "140px",
              margin: 0,
              padding: 0,
              "box-shadow": "1px 1px 3px #CED1D9"
             },
            closeBoxMargin: "0 0 -20px 0",
            closeBoxURL: "/wp-content/themes/WCMRC/assets/images/close-x.svg",
            infoBoxClearance: new google.maps.Size(1, 1),
            isHidden: false,
            pane: "floatPane",
            enableEventPropagation: false
          };

          var boxText = document.createElement("div");
          boxText.style.cssText = "border: 0 solid black; margin: 0; background: #ffffff; padding: 0;";

          myOptions.content = boxText;
          var ib = new InfoBox(myOptions);

          // const vesselOptions = {
          // // content: boxText,
          //   disableAutoPan: false,
          //   maxWidth: 0,
          //   pixelOffset: new google.maps.Size(50, -55),
          //   zIndex: null,
          //   boxStyle: {
          //     background: "#ffffff",
          //     opacity: 1,
          //     width: "350px",
          //     height: "140px",
          //     margin: 0,
          //     padding: 0,

          //    },
          //   closeBoxMargin: "0",
          //   closeBoxURL: "/wp-content/themes/WCMRC/assets/images/close-x.svg",
          //   infoBoxClearance: new google.maps.Size(1, 1),
          //   isHidden: false,
          //   pane: "floatPane",
          //   enableEventPropagation: false
          // };

          // const vesselText = document.createElement("div");
          // vesselText.style.cssText = "border: 0 solid black; margin: 0; background: #ffffff; padding: 0;";

          // vesselOptions.content = vesselText;
          // const vb = new InfoBox(vesselOptions);
            //added

            for (var i = 0; i < response.features.length; i++) {

              var coords = response.features[i].geometry.coordinates;
              // console.log(coords);
              var latLng = new google.maps.LatLng(coords[1],coords[0]);
              // console.log(latLng);
              var id = response.features[i].id;
              // console.log(id);
              var name = response.features[i].properties.Vessel;
              // console.log(name);
              var description = response.features[i].properties.Description;
               // console.log(description);
              var image = response.features[i].properties.Photo.replace('http://wcmrc.com','');
               // console.log(image);
              var direction = response.features[i].properties.COURSE;
               // console.log(direction);
              var timestamp = response.features[i].properties.TIMESTAMP;
              var datestring = timestamp2date(timestamp);
                // console.log(timestamp);
                // console.log(datestring);
              var marker = new google.maps.Marker({
                position: latLng,
                map: map,
                icon: {
                  path: 'M3.5,11.5 L3.5,18.5 L22.8246095,18.5 L27.1996095,15 L22.8246095,11.5 L3.5,11.5 Z',
                    fillColor: '#3490C9',
                    fillOpacity: 1,
                    scale: 1,
                    strokeColor: '#3490C9',
                    rotation: parseFloat(direction)
                    // rotation: parseFloat(ship.shipHeading.split(" deg").join(""))
                },
              });
              // console.log(featuremarker);

               // console.log(featuremarker);

              const vesselmarkup = `
                  <div class="marker__infobox flex-grid flex-grid--fluid-gutter">
                    <div class="col50 u-p10">
                      <h4>
                        ${name}
                      </h4>
                      <p>${description}</p>
                    </div>
                    <div class="col40">
                      <div class="post-thumbnail">
                            <img class="u-ofit" src="${image}" alt="" />
                      </div>
                    </div>
                  </div>
              `;


              google.maps.event.addListener(marker, "click", function() {
                  boxText.innerHTML = vesselmarkup;
                  ib.open(map, this);
                  map.panTo(ib.getPosition());
                  console.log(datestring);
              });

              google.maps.event.addListener(map, 'click', function() {
                if(ib) {
                  ib.close();
                }
              });

              // google.maps.event.addListener(google.maps.Marker, 'click', function() {
              //   if(ib) {
              //     ib.close();
              //   }
              // });

              // add to array
              // mapFeatures.push( vesselmarker );


              //end added
           }


		 //    if( mapFeatures && mapFeatures.length) {

   //          for (var i = 0; i < mapFeatures.length; i++) {
   //              mymap.data.remove(mapFeatures[i]);
   //           }
			// }
   //         mapFeatures = mymap.data.addGeoJson(vessels_geojon);
		 //    console.log('layer refreshed');
		 }


  function requestFailed(error, io){
          console.log('request to vessels layer failed');
        }

 });

}

//refresh vessels
function refresh_vessels(map,interval_minutes) {
setInterval(function(){add_vessels(map);},interval_minutes*60*1000);
console.log('vessels-refreshed');
}
